// Extracted from Orders.jsx to keep that file lean.
// Renders inside a <Dialog> — parent controls open/close via <DialogTrigger> / state.
import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";

export default function QuickCustomerDialog({ onDone }) {
  const [f, setF] = useState({
    party_name: "", party_code: "", location: "", gstin: "",
    contact_person: "", phone: "",
    corporate_address: "", delivery_address: "",
  });

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();               // don't bubble to parent forms (e.g. MJC form)
    try {
      const { data } = await api.post("/customers", f);
      toast.success("Customer added"); onDone(data);
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <DialogContent className="rounded-sm max-w-2xl max-h-[85vh] overflow-y-auto">
      <DialogHeader><DialogTitle className="font-display">Quick Add Customer</DialogTitle></DialogHeader>
      <form onSubmit={submit} className="grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className="label-caps block mb-1.5">Party Name</label>
          <Input data-testid="quick-cust-name" value={f.party_name} onChange={(e) => setF({ ...f, party_name: e.target.value })} className="rounded-sm" required />
        </div>
        <div>
          <label className="label-caps block mb-1.5">Party Code / Unit</label>
          <Input data-testid="quick-cust-code" value={f.party_code} onChange={(e) => setF({ ...f, party_code: e.target.value })} className="rounded-sm" />
        </div>
        <div>
          <label className="label-caps block mb-1.5">Location (short)</label>
          <Input data-testid="quick-cust-location" value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} className="rounded-sm" />
        </div>
        <div>
          <label className="label-caps block mb-1.5">GSTIN</label>
          <Input data-testid="quick-cust-gstin" value={f.gstin} onChange={(e) => setF({ ...f, gstin: e.target.value })} className="rounded-sm" />
        </div>
        <div>
          <label className="label-caps block mb-1.5">Phone</label>
          <Input data-testid="quick-cust-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="rounded-sm" />
        </div>
        <div className="col-span-2">
          <label className="label-caps block mb-1.5">Contact Person</label>
          <Input data-testid="quick-cust-contact" value={f.contact_person} onChange={(e) => setF({ ...f, contact_person: e.target.value })} className="rounded-sm" />
        </div>
        <div className="col-span-2">
          <label className="label-caps block mb-1.5">Corporate / Registered Address</label>
          <textarea
            data-testid="quick-cust-corp-addr"
            value={f.corporate_address}
            onChange={(e) => setF({ ...f, corporate_address: e.target.value })}
            className="w-full rounded-sm border border-neutral-200 px-3 py-2 text-sm"
            rows={2}
            placeholder="HQ / GSTIN registered address"
          />
        </div>
        <div className="col-span-2">
          <label className="label-caps block mb-1.5">Delivery / Shipping Address</label>
          <textarea
            data-testid="quick-cust-deliv-addr"
            value={f.delivery_address}
            onChange={(e) => setF({ ...f, delivery_address: e.target.value })}
            className="w-full rounded-sm border border-neutral-200 px-3 py-2 text-sm"
            rows={2}
            placeholder="Factory / warehouse where labels are shipped"
          />
        </div>
        <DialogFooter className="col-span-2">
          <Button data-testid="quick-cust-submit" type="submit" className="rounded-sm bg-[#FF5A00] hover:bg-[#e04f00]">Add</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
}
